<default-sub-navigation
  [options]="options"
  [itemsType]="'sessions'"
  [broadcastConfig]="broadcastConfig"
  [favorites]="favorites$ | async"
  [recent]="recents$ | async"
  [suggested]="suggested$ | async"
  [loading]="loading$ | async"
  (markItemAsFavorite)="markItemAsFavorite($event)"
  (unmarkItemAsFavorite)="unmarkItemAsFavorite($event)"
  (removeFromSuggested)="removeFromSuggested($event)"></default-sub-navigation>
<onboarding
  *ngIf="onboarding && onboarding.shouldShow"
  [delegate]="onboarding.delegate"
  [steps]="onboarding.totalSteps"
  [startFromStep]="onboarding.startingStep"
  [previewOverrides]="onboarding.previewOverrides"
  [disableTracking]="true"
  section="navigation"
  popoverTitle="meet_the_new_nav"
  description="meet_the_new_nav_text">
</onboarding>
